import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { ApiService } from 'services';

import ErrorGraphic from '../ErrorGraphic';

const NoInternetPage = ({ title, caption, buttonText }) => {
  const processRetries = () => {
    console.log(`Retry actions - ${ new Date() }`);
    ApiService.processQueuedPromises();
  };

  return (<div>
    <ErrorGraphic />
    <div className="message-404-box">
      <h1>{ title }</h1>
      <p>{ caption }</p>
      <div className="buttons-con">
        <div className="action-link-wrap">
          <button type="button" className="btn btn-primary mr" onClick={ processRetries }>{ buttonText }</button>
          <Link to="/" className="link-button ml">Go to home page</Link>
        </div>
      </div>
    </div>
  </div>);
};

NoInternetPage.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  buttonText: PropTypes.string
};

NoInternetPage.defaultProps = {
  title: 'Internet Connection Lost',
  caption: 'Please check your internet connection and use the button below to try again.',
  buttonText: 'Try Again'
};

export default NoInternetPage;
